export default "__VITE_ASSET__Cz6pC_Iu__"